import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import MetricsGrid from './MetricsGrid';
import EmailMarketing from './EmailMarketing';
import ProfessionalAudience from './ProfessionalAudience';
import EngagementTabs from './EngagementTabs';
import GeographicReach from './GeographicReach';
import LinkedInAnalytics from './LinkedInAnalytics';
import SocialMediaImpact from './SocialMediaImpact';
import VideoShowcase from './VideoShowcase';
import PracticeAreas from './PracticeAreas';
import RenewalCTA from './RenewalCTA';

const Dashboard = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const sectionVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      className="min-h-screen"
      variants={containerVariants}
      initial="hidden"
      animate={isLoaded ? "visible" : "hidden"}
    >
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-12">
        <motion.div variants={sectionVariants}>
          <MetricsGrid />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <EmailMarketing />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <ProfessionalAudience />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <EngagementTabs />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <GeographicReach />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <LinkedInAnalytics />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <SocialMediaImpact />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <VideoShowcase />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <PracticeAreas />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <RenewalCTA />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Dashboard;